import React, { Component } from 'react';
import Parse from 'parse';
import $ from "jquery";
class Leftsidebar extends Component {
  constructor(props) {
    super(props);
    Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
    Parse.serverURL = "https://parse.joelskitchen.com/parse";
    //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

    var now = new Date();
    let currentUser = Parse.User.current(); 
    let displayUsername='';
    if(currentUser)
    {
        displayUsername = currentUser.get("displayUsername");
    }

    this.usernameParam = displayUsername;
    this.state = {
        users: {},
        created_at: now.getTime(),
        userImage: null
    };
    this.getSuggestedUsers();
    this.queryForUserRecordData();
    this.getMenu();
    this.getTabletMenu();
    // this.getNotification();
    // this.getNotificationClose();
  }     

  queryForUserRecordData() {
      var query = new Parse.Query('User');       
      query.equalTo("displayUsername", this.usernameParam);
      query.include("image");
      query.include("thumbnail");   
      var self = this;
      query.first().then(function(result){
          if(result){       
              self.setState({userImage: result.get("profilePictureSmall").url()});
          } else {

          }
      }, function(error){
              console.error("Error loading post Error: " + error);
              //promise.error(error);
      });
  }

    getSuggestedUsers() {
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.include("username");
      query.descending('_created_at');
      var self = this;
       query.find().then(function(result){
            if(result){
               self.setState({users: result});
            } else {
                console.log("No user found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });

    }

    getMenu() {
      let menuval=$('#menuval').val();
      if(menuval==false) {
        $(".pagelink-grp").css({"height": "auto", "visibility" : "visible", "opacity": "1"});
        $('#menuval').val(1);
      } else { 
        $(".pagelink-grp").css({"height": "0", "visibility" : "hidden", "opacity": "0"});
        $('#menuval').val(0);
      } 
    }
    notlogin() {
      $('#login_popup_btn').trigger('click');

    }
    getNotification() {
      $('#notf_sidebar').val(0);
      let notf_sidebar=$('#notf_sidebar').val();
      if(notf_sidebar!=true) {
        $(".notf_sidebar").css({"left": "398px"});
        $('#notf_sidebar').val(1);
        $('#notf_sidebar_close').val(0);
      } else { 
        $(".notf_sidebar").css({"left": "-398px"});
        $('#notf_sidebar').val(0);
        $('#notf_sidebar_close').val(1);
      }
    } 

    getTabletMenu() {
      let tabletMenu=$('#tabletMenu').val();
      if(tabletMenu==false) {
        $(".hamburger_wrap .menu_wrpa").css({"height": "auto", "visibility" : "visible", "opacity": "1"});
        $(".hamburger_wrap .hamburger").addClass('active');
        $('#tabletMenu').val(1);
      } else { 
        $(".hamburger_wrap .menu_wrpa").css({"height": "0", "visibility" : "hidden", "opacity": "0"});
        $(".hamburger_wrap .hamburger").removeClass('active');
        $('#tabletMenu').val(0);
      }
    }
    // getNotificationClose() {
    //   let notf_sidebar_close=$('#notf_sidebar_close').val('');
    //   let notf_sidebar=$('#notf_sidebar').val('');
    //   if(notf_sidebar_close==true) {
    //     $(".notf_sidebar").css({"left": "398px"});
    //     $('#notf_sidebar_close').val(0);
    //     $('#notf_sidebar').val(1);
    //   } else { 
    //     $(".notf_sidebar").css({"left": "-398px"});
    //     $('#notf_sidebar_close').val(1);
    //     $('#notf_sidebar').val(0);
    //   }
    // } 
    renderUsers()
    {
      let buffer = [];

        if (this.state.users)
        {
            for (var i = 0; i < this.state.users.length; i++)
            {
                var user = this.state.users[i];
                var profile_picture= user.get("profilePictureSmall").url();
                if(profile_picture!==undefined)
                {
                  profile_picture=profile_picture;
                }else
                {
                  profile_picture="/images/menu-account.svg";
                }
                buffer.push(
                   <li className='menu'  key={69*i}>
                        <a href={'/user/'+user.get("displayUsername")}  title={user.get("displayUsername")} className='media'>
                          <div className="media-left">

                            <img src={profile_picture} width="40px" height="40px" alt="itsallgoodvegan"/>
                          </div>
                          <div className="media-body">
                            <h6 className="mt-0">{user.get("displayUsername")}</h6>
                            <span>{user.get("displayName")}</span>
                          </div>
                        </a>
                      </li>
                  
                );
            }
        }

        return (  <ul className='list_grp'>
                {buffer}
                </ul>
               
        );

    }
  

  render() {

    let getLoggedinUsername=localStorage.getItem('username');
    return (
      <React.Fragment>
        <div className='wrapper'>
          <div className='inner'>
            <div className='dt_sidebar'>
              <aside className="menu_sidebar">
              {getLoggedinUsername!=null?
                <ul className='list_grp'>
                
                  {/*<li className='menu'>
                    <a href='/' title='Home'>
                      <span className='thumb'>
                        <img src="/images/menu-home.svg" width="40px" height="40px" alt="Home"/>
                      </span>
                      <span className='name'>Home</span>
                    </a>
                  </li>*/}
                  <li className='menu'>
                    <a href='/'  title="Home">
                      <span className='thumb'>
                       {/* <img src="/images/menu-search.svg" width="40px" height="40px" alt="Explore"/>*/} <img src="/images/menu-home.svg" width="40px" height="40px" alt="Home"/>
                      </span>
                      <span className='name'>Home</span>
                    </a>
                  </li>
                  <li className='menu dm'>
                    <a href='/messages' title='Messages'  onClick={this.notlogin}>
                      <span className='thumb'>
                        <img width="40px" height="40px"  src="/images/direct_message.png" alt="Messages" />                        
                      </span>
                      <span className='name'>Messages</span>
                    </a>
                  </li> 
                  
                  <li className='menu'>
                    <a href='javascript:void(0);' title="Create" type="button" data-toggle="modal" data-target="#createPostModal" >
                      <span className='thumb'>
                        <img src="/images/create_post_menu.svg" width="40px" height="40px" alt="Create"/>
                      </span>
                      <span className='name'>Create</span>
                    </a>
                  </li> 
                  <li className='menu'>
                    <a href='javascript:void(0);' className='menu-notf-lnk' title='Notifications' onClick={this.getNotification}>
                      <span className='thumb'>
                        <img src="/images/menu-notifications.svg" width="40px" height="40px" alt="Notifications"/>
                      </span>
                      <span className='name'>Notifications</span>
                    </a>
                  </li>
                  
                  <li className='menu userProfile'>
                    <a href='/my-profile' title='Profile'>
                      <span className='thumb'>
                        {this.state.userImage!==null? <img height="150" width="150" className="userProfileImageLarge"  src={this.state.userImage}  alt={this.usernameParam} />
                            :<img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />
                        }
                      </span>
                      <span className='name'>Profile</span>
                    </a>
                  </li> 
                                  
                </ul>:  <ul className='list_grp'>                
                    {/*  <li className='menu'>
                    <a href='/' title='Home'>
                      <span className='thumb'>
                        <img src="/images/menu-home.svg" width="40px" height="40px" alt="Home"/>
                      </span>
                      <span className='name'>Home</span>
                    </a>
                  </li>*/}
                {/* onClick={this.notlogin}*/}
                 <li className='menu'>
                    <a href='/'  title="Home">
                      <span className='thumb'>
                       {/* <img src="/images/menu-search.svg" width="40px" height="40px" alt="Explore"/>*/} <img src="/images/menu-home.svg" width="40px" height="40px" alt="Home"/>
                      </span>
                      <span className='name'>Home</span>
                    </a>
                  </li>   
                  <li className='menu dm'>
                    <a href='javascript:void(0);' title='Messages'  onClick={this.notlogin}>
                      <span className='thumb'>
                        <img width="40px" height="40px"  src="/images/direct_message.png" alt="Messages" />                        
                      </span>
                      <span className='name'>Messages</span>
                    </a>
                  </li>              
                  <li className='menu'>
                    <a href='javascript:void(0);'  onClick={this.notlogin} title="Create" >
                      <span className='thumb'>
                        <img src="/images/create_post_menu.svg" width="40px" height="40px" alt="Create"/>
                      </span>
                      <span className='name'>Create</span>
                    </a>
                  </li> 
                  <li className='menu'>
                    <a href='javascript:void(0);'  onClick={this.notlogin} className='menu-notf-lnk' title='Notifications'>
                      <span className='thumb'>
                        <img src="/images/menu-notifications.svg" width="40px" height="40px" alt="Notifications"/>
                      </span>
                      <span className='name'>Notifications</span>
                    </a>
                  </li>    
                                
                  <li className='menu userProfile'>
                    <a href='javascript:void(0);' title='Profile'  onClick={this.notlogin}>
                      <span className='thumb'>
                        <img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />                        
                      </span>
                      <span className='name'>Profile</span>
                    </a>
                  </li> 
                  </ul>



              }     
              </aside>
              <aside className='suggested_acunt'>
                <h2>Suggested Accounts</h2>           
                {this.renderUsers()}               
              </aside>
              <aside className='pagelink-grp'>
                <ul className='list_grp'>
                  <li className='menu'>
                    <a href='mailto:information@joelskitchen.com' title='Contact Us'>Contact Us</a>
                  </li>
                  <li className='menu'>
                    <a href='https://joelskitchen.com/privacy' title='Privacy Policy'>Privacy Policy</a>
                  </li>
                  <li className='menu'>
                    <a href='https://joelskitchen.com/terms' title='Terms'>Terms</a>
                  </li>
                </ul>
                <ul className='list_grp'>
                  <li className='menu'>
                    <a href='https://create.joelskitchen.com/business/'  target='_blank' title='Creator Marketplace'>Creator Marketplace</a>
                  </li>
                  <li className='menu'>
                    <a href='https://joelskitchen.com/creatordirectory'  target='_blank'  title='Creator Directory '>Creator Directory </a>
                  </li>
                   
                </ul>
                <ul className='list_grp'>
                  <li className='menu'>
                    <a href='https://www.instagram.com/joels_kitchen/' target='_blank' title='Instagram'>Instagram</a>
                  </li>
                  <li className='menu'>
                    <a href='https://www.tiktok.com/@joels_kitchen' target='_blank' title='TikTok'>TikTok</a>
                  </li>
                  <li className='menu'>
                    <a href='https://www.facebook.com/joelskitchenapp' target='_blank' title='Facebook'>Facebook</a>
                  </li>
                  <li className='menu'>
                    <a href='https://www.pinterest.com/joelskitchen/' target='_blank' title='Pinterest'>Pinterest</a>
                  </li>
                </ul>
              </aside>
              <div className='hamburger_wrap'>
                <input type="hidden" name="tabletMenu" id="tabletMenu" value="0" />
                <button className='hamburger' onClick={this.getTabletMenu}>
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                </button>
                <div className='menu_wrpa'>
                  <aside className='suggested_acunt'>
                    <h2>Suggested Accounts</h2>           
                    {this.renderUsers()}               
                  </aside>
                  <aside className='pagelink-grp'>
                    <ul className='list_grp'>
                      <li className='menu'>
                        <a href='javascript:void(0);' title='Contact Us'>Contact Us</a>
                      </li>
                      <li className='menu'>
                        <a href='javascript:void(0);' title='Privacy Policy'>Privacy Policy</a>
                      </li>
                      <li className='menu'>
                        <a href='javascript:void(0);' title='Terms'>Terms</a>
                      </li>
                    </ul>
                    <ul className='list_grp'>
                      <li className='menu'>
                        <a href='https://create.joelskitchen.com/business/creators'  target='_blank'  title='Creator Directory '>Creator Directory </a>
                      </li>
                      <li className='menu'>
                        <a href='https://create.joelskitchen.com/business/'  target='_blank' title='Creator Marketplace'>Creator Marketplace</a>
                      </li>
                    </ul>
                    <ul className='list_grp'>
                      <li className='menu'>
                        <a href='https://www.instagram.com/joels_kitchen/' target='_blank' title='Instagram'>Instagram</a>
                      </li>
                      <li className='menu'>
                        <a href='https://www.tiktok.com/@joels_kitchen' target='_blank' title='TikTok'>TikTok</a>
                      </li>
                      <li className='menu'>
                        <a href='https://www.facebook.com/joelskitchenapp' target='_blank' title='Facebook'>Facebook</a>
                      </li>
                      <li className='menu'>
                        <a href='https://www.pinterest.com/joelskitchen/' target='_blank' title='Pinterest'>Pinterest</a>
                      </li>
                    </ul>
                  </aside>
                </div>
              </div>
            </div>
            <div className='mb_sidebar'>
              <aside className="menu_sidebar">
                <ul className='list_grp'>
                 {/* <li className='menu'>
                    <a href='/'><img src="/images/menu-home.svg" width="40px" height="40px" alt="Home"/>Home</a>
                  </li>*/}
                  <li className='menu'>
                    <a href='/'>{/*<img src="/images/menu-search.svg" width="40px" height="40px" alt="Explore"/>*/}<img src="/images/menu-home.svg" width="40px" height="40px" alt="Explore"/>Explore</a>
                  </li>
                  {getLoggedinUsername!=null?
                  <li className='menu'>
                    <a href='javascript:void(0);' type="button" data-toggle="modal" data-target="#createPostModal" ><img src="/images/create_post_menu.svg" width="40px" height="40px" alt="Create"/>Create</a>
                  </li> 
                  :''}  
                  <li className='menu'>
                    <a href='javascript:void(0);' className='menu-notf-lnk' title='Notifications' onClick={this.getNotification}><img src="/images/menu-notifications.svg" width="40px" height="40px" alt="Notifications"/>Notifications</a>
                  </li>
                  {getLoggedinUsername!=null?
                    <li className='menu userProfile'>
                      <a href='/my-profile'>  {this.state.userImage!==null?
                            <img height="150" width="150" className="userProfileImageLarge"  src={this.state.userImage}  alt={this.usernameParam} />
                            :<img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />
                        } Profile</a>
                    </li> 
                  :''}
                  <li className="other_link">
                    <button className='hamburger' onClick={this.getMenu}>

                      <span className="bar"></span>
                      <span className="bar"></span>
                      <span className="bar"></span>
                    </button>
                    <div className='pagelink-grp'>
                      <ul className='list_grp'>
                        <li className='menu'>
                          <a href='javascript:void(0);' title='Contact Us'>Contact Us</a>
                        </li>
                        <li className='menu'>
                          <a href='javascript:void(0);' title='Privacy Policy'>Privacy Policy</a>
                        </li>
                        <li className='menu'>
                          <a href='javascript:void(0);' title='Terms'>Terms</a>
                        </li>
                       
                        <li className='menu'>
                          <a href='https://create.joelskitchen.com/business/creators'  target='_blank'  title='Creator Directory '>Creator Directory </a>
                        </li>
                         <li className='menu'>
                         {/* <a href='javascript:void(0);' title='Advertise'>Advertise</a>*/}
                         <a href='https://create.joelskitchen.com/business'  target='_blank' title='Creator Marketplace'>Creator Marketplace</a>
                        </li>
                        <li className='menu'>
                          <a href='https://www.instagram.com/joels_kitchen/' target='_blank' title='Instagram'>Instagram</a>
                        </li>
                        <li className='menu'>
                          <a href='https://www.tiktok.com/@joels_kitchen' target='_blank' title='TikTok'>TikTok</a>
                        </li>
                        <li className='menu'>
                          <a href='https://www.facebook.com/joelskitchenapp' target='_blank' title='Facebook'>Facebook</a>
                        </li>
                        <li className='menu'>
                          <a href='https://www.pinterest.com/joelskitchen/' target='_blank' title='Pinterest'>Pinterest</a>
                        </li>
                      </ul>
                    </div>
                     <input type="hidden" name="menuval" id="menuval" value="0" />
                  </li>                 
                </ul>
              </aside>
            </div>
          </div>
        </div>
        
      </React.Fragment>
    );
  }
}

export default Leftsidebar;



// WEBPACK FOOTER //
// ./src/Leftsidebar.jsx